<template>
    <div>

        <div class="col-xs-12 agx-list-oneInRow" style="height:150px">
            <div>
                <div style="text-align:right;">
                        
                    </div>
                <h4>

                    <router-link :to="{name:'detail',query:{postId:item.postId,scode:item.shopCode}}">
                        {{item.title}}
                    </router-link>
                </h4>

                <div class="row">
                    <div class="col-xs-12 col-md-12">
                        <div style="white-space:pre-line;width:100%;">
                            {{cpdTextMsg}}
                        </div>
                    </div>

                    <div style="position:relative;top:57px;height: 30px; background: rgb(145,145,145); background: rgb(145,145,145); background: linear-gradient(0deg, rgba(145,145,145,0.3743872549019608) 0%, rgba(255,255,255,0.3519782913165266) 100%); "></div>

                </div>               



            </div>
            
        </div>
    </div>
</template>
<script>
    
    export default {
        components: {
            
        },
        props: ["item","itemType"],
        data: function () {
            return {

            }
        },
        computed: {
            cpdTextMsg: function () {
                var it = this.item.textMsg;
                if (it) {
                    if (it.length > 50) {
                        return it.substring(0, 30) + "......";
                    }
                }
                return it;
            }
        },
        mounted: function () {

        }
    }
</script>